import { GlowFilter, MovieClip, TextFormat } from "../runtime";
import { SCORE_POP_GLOW, SCORE_POP_GLOW_PLAIN } from "./data/swordColours";
import { FONT_BODY, TEXT_COLOURS, createTextField } from "./textStyle";

/**
 * The score number that floats up off a killed enemy. Bigger scores get a
 * bigger font and a proportionally longer life; multiplied ones are glowed in
 * the colour of the sword that earned them.
 */
export class ScorePop extends MovieClip {
  private readonly lifeLimit: number;
  private life = 0;
  private fading = false;
  private alphaCurrent = 100;

  constructor(
    x: number,
    y: number,
    amount: number,
    multiplied: boolean,
    swordLevel: number,
  ) {
    super();
    const format = new TextFormat();
    this.x = x;
    this.y = y;
    format.align = "center";
    format.font = FONT_BODY;
    format.color = TEXT_COLOURS.white;
    let scoreSize = 12 + Math.floor(amount * 0.05);
    if (scoreSize < 14) {
      scoreSize = 14;
    }
    if (scoreSize > 36) {
      scoreSize = 36;
    }
    format.size = scoreSize;
    createTextField(this, format, {
      width: 175,
      height: Math.round(scoreSize * 1.5),
      centerX: true,
      y: scoreSize * -0.5,
      text: String(amount),
    });
    this.lifeLimit = 10 + Math.round(scoreSize * 2);
    const glowColour = multiplied
      ? (SCORE_POP_GLOW[swordLevel] ?? 0)
      : SCORE_POP_GLOW_PLAIN;
    this.filters = [new GlowFilter(glowColour, 1, 2, 2, 4, 1)];
  }

  /** True once the number has drifted up and faded out. */
  update(): boolean {
    this.y = this.y - 1;
    if (!this.fading) {
      ++this.life;
      if (this.life >= this.lifeLimit) {
        this.fading = true;
      }
    } else if (this.alphaCurrent > 0) {
      this.alphaCurrent -= 10;
      this.alpha = this.alphaCurrent * 0.01;
      if (this.alphaCurrent === 0) {
        return true;
      }
    }
    return false;
  }
}
